// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BankOutlinedSvg from "@fishx/icons-svg/es/asn/BankOutlined";
import FishxIcon from '../components/FishxIcon';

var BankOutlined = function BankOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BankOutlinedSvg
  }));
};

BankOutlined.displayName = 'BankOutlined';
export default React.forwardRef(BankOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BankOutlined.js
// module id = 2047
// module chunks = 0